import React, { useEffect } from "react";
import StudentsTable from "./StudentsTable";
import StudentsInvitePanel from "./StudentsInvitePanel";
import StudentsDetailsPage from "./StudentDetailsPage";
import { ApplicationState } from "../../../../../store";
import { useDispatch, useSelector } from "react-redux";
import { StudentInfo } from "../../../../../store/onboarding/types";
import { push } from "connected-react-router";
import LoadingIndicator from "../../LoadingIndicator";
import { changeStudentsFilter, getStudents } from "../../../../../store/onboarding/actions";
import StudentEditModal from "./StudentEditModal";
import { changeExitedStudentsGroup, changeShowArchivedGroups } from "../../../../../store/dataFilter/actions";
import useUserRole from "../../../../../utils/hooks/useUserRole";

type Props = { id?: string };

const StudentsPane = ({ id }: Props) => {
  const students = useSelector<ApplicationState, StudentInfo[]>(
    (s) => s.onboarding.studentsRoster
  );
  const isLoadingGetStudents = useSelector<ApplicationState, boolean>(
    (s) => s.onboarding.isLoading.getStudents
  );
  const studentById = useSelector<ApplicationState, StudentInfo | undefined>(
    (s) => s.onboarding.studentsRoster.find((st) => st.unique_id === id)
  );

  const dispatch = useDispatch();

  const { isTeacher } = useUserRole()

  useEffect(() => {
    if (!(students.length || isLoadingGetStudents)) {
      dispatch(getStudents());
    }
    dispatch(changeShowArchivedGroups(false)); //initial load of student detail page
    dispatch(changeExitedStudentsGroup(false)); //initial load of student detail page
  }, []);

  useEffect(() => {
   dispatch(changeStudentsFilter(''))
  }, []) 

  // useEffect(() => {
  //   if (studentsNotEmpty && !studentById) {
  //     dispatch(push("/rosters/students"));
  //   }
  // }, [studentsNotEmpty, studentById]);

  if (isLoadingGetStudents) {
    return <LoadingIndicator type="table" rows={20} columns={6} />;
  }
  if (studentById) {
    return <StudentsDetailsPage student={studentById} />;
  }
  if (students.length) {
    return (
      <>
        <StudentsTable />
        <StudentEditModal />
      </>
    );
  }
  return !isTeacher 
          ? <StudentsInvitePanel /> 
          : <div className="onboardingSecondStepEmptyContainer">
              <h3>
                Students will appear here once they are added by a District Admin or Coach.
              </h3>
            </div>;
};

export default StudentsPane;
